// IconWorker Marquee - seamless infinite scroll (RTL compatible)
(function() {
  function initMarquee(container) {
    var track = container.querySelector('[data-iw-marquee-track]');
    if (!track) return;

    // Remove any existing clones first
    track.querySelectorAll('[data-clone]').forEach(function(c) { c.remove(); });

    // Get original items as array
    var originals = Array.from(track.children);
    if (originals.length === 0) return;

    // Measure the width of the original set using bounding box
    var firstRect = originals[0].getBoundingClientRect();
    var lastRect = originals[originals.length - 1].getBoundingClientRect();
    // In RTL, first item is on the right, last item is on the left
    var originalSetWidth = Math.abs(firstRect.right - lastRect.left);

    // Fallback: sum individual widths if bounding box gives 0
    if (originalSetWidth <= 0) {
      originalSetWidth = 0;
      originals.forEach(function(item) {
        originalSetWidth += item.getBoundingClientRect().width;
      });
    }

    // Clone until total width covers: originalSetWidth + containerWidth (so screen is always full)
    var containerWidth = container.offsetWidth;
    var needed = originalSetWidth + containerWidth * 2;
    var currentWidth = originalSetWidth;
    var safety = 0;

    while (currentWidth < needed && safety < 50) {
      originals.forEach(function(item) {
        var clone = item.cloneNode(true);
        clone.setAttribute('data-clone', 'true');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
      currentWidth += originalSetWidth;
      safety++;
    }

    // Detect RTL
    var isRTL = getComputedStyle(container).direction === 'rtl' ||
                document.documentElement.getAttribute('dir') === 'rtl';

    // Set the animation distance
    // In RTL: content flows right-to-left, so we need positive translateX to scroll left
    // In LTR: content flows left-to-right, so we need negative translateX to scroll left
    var distance = Math.ceil(originalSetWidth);
    if (isRTL) {
      track.style.setProperty('--marquee-distance', distance + 'px');
    } else {
      track.style.setProperty('--marquee-distance', '-' + distance + 'px');
    }
  }

  function initAll() {
    document.querySelectorAll('[data-iw-marquee]').forEach(initMarquee);
  }

  // Run after a short delay to ensure layout is complete
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initAll, 150);
    });
  } else {
    setTimeout(initAll, 150);
  }

  // Re-init on resize (debounced)
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initAll, 300);
  });
})();
